import styled from 'styled-components';

export const EcoleFrancaiseLogoDiv = styled.div`
    svg {
        width: 150px;
        height: auto;
        fill: #028166;
        #logo-horizontal-brand-name {
           fill: #034e3e;
        }
    }
`;

export const IPacLogoDiv = styled.div`
    svg {
        width: 70px;
        height: auto;
        fill: white;
        .bg {
            fill: #bd2d23;
        }
        .shadow {
            fill: #dc9191;
        }
        text {
            font-size: 48px;
        }
    }
`;

export const MultiSitesDiv = styled.div`
    svg {
        max-width: 300px;
        height: auto;
        fill: none;
        stroke: #004c3c;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 7px;
        .formation-name {
            font-family: 'Magenos';
            font-size: 36px;
            font-weight: 600;
            fill: #0f4e3f;
            stroke: none;
        }
        .by-ecolefrancaise {
            font-family: 'Magenos';
            font-size: 24px;
            font-weight: 600;
            text-transform: uppercase;
            letter-spacing: 2.5px;
            fill: #0f4e3f;
            stroke: none;
        }
    }
`;